import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { useStageMetadataFacade } from '../apis/facades/useStageMetadataFacade';
import {
  selectOpportunityTypesList,
  setOpportunityLists,
} from '../reducers/funnel-flow-page/stageDialogReducer';
import flatten from 'lodash/flatten';

const useStageMetadata = () => {
  const dispatch = useDispatch();
  const options = useSelector(selectOpportunityTypesList);

  const { get_opportunityList } = useStageMetadataFacade();

  const getOpportunityStageMetadataOptions = async (crmOrgId: string) => {
    const types = await get_opportunityList(crmOrgId);
    dispatch(setOpportunityLists({ types }));
  };

  const mapForecastCategoryValueToLabel = useCallback(
    (value: string) => {
      const forecastCategories = flatten(options?.map((item) => item.forecastCategories));
      return forecastCategories.find((fc) => fc.value === value)?.label ?? value;
    },
    [options],
  );

  return {
    getOpportunityStageMetadataOptions,
    mapForecastCategoryValueToLabel,
  };
};

export { useStageMetadata };
